"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;
exports.setDirectionOnStoryChange = setDirectionOnStoryChange;
var _react = _interopRequireDefault(require("react"));
var _addons = require("@storybook/addons");
var _coreEvents = require("@storybook/core-events");
var _RTLPanel = _interopRequireDefault(require("./containers/RTLPanel"));
var _constants = require("./constants");
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function register() {
  _addons.addons.register(_constants.ADDON_ID, function (api) {
    var channel = _addons.addons.getChannel();
    setDirectionOnStoryChange(api);
    _addons.addons.addPanel(_constants.PANEL_ID, {
      title: 'RTL',
      render: function render(_ref) {
        var active = _ref.active,
          key = _ref.key;
        /* eslint-disable-line react/prop-types, react/display-name */
        if (!active) {
          return null;
        }
        return /*#__PURE__*/_react["default"].createElement(_RTLPanel["default"], {
          key: key,
          channel: channel,
          api: api
        });
      }
    });
  });
}
function setDirectionOnStoryChange(api) {
  var channel = _addons.addons.getChannel();

  // Keep track of the most recent value that was a result of user interaction
  // so we can return to this value whenever a story is opened that does not have a parameter
  var lastUserInteractionValue;
  // Whenever a story is rendered, update the state to represent the parameter value of the story.
  // We do this here and not in the panel component because we want the parameter to be respected
  // even if the panel is never opened
  channel.on(_coreEvents.STORY_RENDERED, function (_) {
    var _channel$last;
    var lastUpdate = (_channel$last = channel.last(_constants.UPDATE_EVENT_ID)) === null || _channel$last === void 0 ? void 0 : _channel$last[0];
    lastUserInteractionValue = lastUpdate !== null && lastUpdate !== void 0 && lastUpdate.userInteraction ? lastUpdate.direction : lastUserInteractionValue;
    var paramValue = api.getCurrentParameter('direction');
    var newDirection;
    if (paramValue) {
      newDirection = paramValue;
    } else if (lastUserInteractionValue) {
      newDirection = lastUserInteractionValue;
    } else {
      newDirection = (0, _utils.getDefaultTextDirection)(api);
    }
    channel.emit(_constants.UPDATE_EVENT_ID, {
      direction: newDirection,
      userInteraction: false
    });
  });
}